import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button", "link"]

    refresh(event) {
        event.preventDefault()

        const element = event.currentTarget
        const cacheKey = element.dataset.cacheKey
        const currentUrl = element.dataset.currentUrl

        if (!cacheKey) {
            console.error("Cache key is required")
            return
        }

        // Disable the button/link and show loading state
        this.setLoadingState(element, true)

        // Make the request to refresh cache
        fetch("/cache_refresh", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({
                cache_key: cacheKey,
                current_url: currentUrl
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    this.showSuccessMessage(data.message)
                } else {
                    this.showErrorMessage(data.error || "Failed to refresh cache")
                }
            })
            .catch(error => {
                console.error("Cache refresh error:", error)
                this.showErrorMessage("Failed to refresh cache. Please try again.")
            })
            .finally(() => {
                // Re-enable the button/link
                this.setLoadingState(element, false)
            })
    }

    setLoadingState(element, loading) {
        if (loading) {
            element.disabled = true
            element.classList.add("opacity-50", "cursor-not-allowed")

            // Find the icon and add spinning animation
            const icon = element.querySelector("svg")
            if (icon) {
                icon.classList.add("animate-spin")
            }

            // Update text if it's a button
            const originalText = element.textContent.trim()
            if (element.tagName === "BUTTON") {
                element.dataset.originalText = originalText
                element.innerHTML = element.innerHTML.replace(originalText.split(" ").slice(-1)[0], "Refreshing...")
            }
        } else {
            element.disabled = false
            element.classList.remove("opacity-50", "cursor-not-allowed")

            // Remove spinning animation
            const icon = element.querySelector("svg")
            if (icon) {
                icon.classList.remove("animate-spin")
            }

            // Restore original text
            if (element.dataset.originalText) {
                element.innerHTML = element.innerHTML.replace("Refreshing...", element.dataset.originalText.split(" ").slice(-1)[0])
                delete element.dataset.originalText
            }
        }
    }

    showSuccessMessage(message) {
        this.showNotification(message, "success")
    }

    showErrorMessage(message) {
        this.showNotification(message, "error")
    }

    showNotification(message, type) {
        // Create a temporary notification element
        const notification = document.createElement("div")
        notification.className = `fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-sm ${
            type === "success"
                ? "bg-green-500 text-white"
                : "bg-red-500 text-white"
        }`
        notification.textContent = message

        document.body.appendChild(notification)

        // Remove after 5 seconds
        setTimeout(() => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification)
            }
        }, 5000)

        // Also trigger a notification dot update if there's a notification system
        this.updateNotificationDot()
    }

    updateNotificationDot() {
        // Trigger an update to the notification bell in the header
        // This will be handled by the existing notification system
        const notificationDot = document.getElementById("notifications-dot-on-bell")
        if (notificationDot) {
            notificationDot.classList.add("animate-pulse")
            setTimeout(() => {
                notificationDot.classList.remove("animate-pulse")
            }, 2000)
        }
    }
}